import React, { useEffect, useState } from "react";
import { FaArrowRight } from "react-icons/fa";
import "./service1.css"
import { Link } from "react-router-dom";
import projectData from "../components/projectdata.js"


function Service4() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fade, setFade] = useState(true); // Control fade animation
  const fabProjects = projectData.filter(project => project["service-type"].includes("fab"));
  const images = fabProjects.map(project => project.images[0]);
  const projectNames = fabProjects.map(project => project["project-name"]);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade-out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        setFade(true); // Fade-in new image
      }, 500); // 500ms fade-out before changing the image
    }, 5000); // Change image every 3s

    return () => clearInterval(interval);
  }, [images.length]);

    return (
      <div className="service1">

        <div className="service1-header">
          <h1>
          งานผลิตสแตนเลสและเหล็กตามแบบ
          </h1>
          <ul>
            <li>บริการตัด ฉลุ เลเซอร์ พับ และเชื่อมตามแบบ</li>
            <li>รองรับงานประเภทชิ้นส่วนอุตสาหกรรม ชิ้นส่วนยานยนต์ ป้าย ตัวอักษร ระแนง ฉลุลาย งานโลโก้และตัวอักษรต่างๆ</li>
          </ul>
        </div>

        { images.length !== 0 &&
        <div className="service-project-preview">
          <img src={images[currentIndex]} alt="" className={`fade ${fade ? "fade-in" : "fade-out"}`}/>
          <div className="banner-absolute-container">
              <p style={{fontStyle: 'italic', fontSize: '12px', fontWeight: '300'}} className="banner-italics">{currentIndex+1}/{images.length}</p>
              <p style={{paddingTop : '8px', fontSize: '14px'}} className="banner-project-name">{projectNames[currentIndex]}</p>
          </div>
        </div>
        }
        
        <div className="detail-section-1">
          <div>
          <h1>คุณภาพเยี่ยม <br />
          ราคาย่อมเยา</h1>
          <p>โรงงานผลิตเอง ทำให้สามารถควบคุมได้ทั้ง <br />
          ราคาและคุณภาพวัสดุ</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section1.png")} alt="" />
        </div>

        <div className="detail-section-2">
          <div>
          <h1>ผลิตและควบคุม <br />
          โดยผู้เชี่ยวชาญ</h1>
          <p>
            มีผู้เชี่ยวชาญควบคุมเครื่องจักร พร้อมประกอบงาน <br />
            โดยช่างผู้ชำนาญเฉพาะทางงานโลหะ <br />
            เรามีช่างเชื่อม ช่างพับ ครบครันจึงมั่นใจได้ว่างาน <br />
            ที่ออกมาได้มาตรฐานตามแบบที่ลูกค้าต้องการ
          </p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section2.png")} alt="" />
        </div>

        <div className="detail-section-3">
          <div>
          <h1>บริการทั่วถึง <br />
          จัดส่งทั่วไทย</h1>
          <p>ให้บริการครอบคลุมทุกพื้นที่ <br />
            รับประกันสินค้าจากร้าน  <br />
          พร้อมจัดส่งสินค้าทั่วประเทศ ไม่ว่าคุณจะอยู่ที่ไหน <br />
          เราพร้อมส่งมอบสินค้าคุณภาพเยี่ยม <br />
          ให้ถึงมือคุณอย่างปลอดภัย</p>
          </div>
          
          <img src={require("../images/ระบบดูดอากาศ/image-section3.png")} alt="" />
        </div>
        
        <Link to="/contact"><p className="contact-link-btn">ขอคำแนะนำจากผู้เชี่ยวชาญ <FaArrowRight className="right-icon" /></p></Link>
        
      </div>
    );
  }
  
  export default Service4;
